import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

const Name: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    fontSize: theme.typography.pxToRem(14),
    height: `calc(${theme.typography.pxToRem(14)} * ${
      theme.typography.body1.lineHeight
    } * 2)`,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      height: `calc(${theme.typography.pxToRem(16)} * ${
        theme.typography.body1.lineHeight
      } * 2)`,
    },
  },
}))(Typography);

export default Name;
